import styled from 'styled-components';
import { device } from './responsives.js';

export const Form = styled.form`
  height: 44px;
  margin-top: 0px;
  display: inline-block;
  vertical-align: center;
  @media ${device.ipadPro}{
    height: auto;
  }
`

export const Input = styled.input`
  display: inline-block;
  min-width: 400px;
  height: 40px;
  border-radius: 2px;
  border: 1px solid #ddd;
  background-color: #ffffff;
  padding-left: 6px;
  font-size: 16px;
  border-radius: 5px;
  @media ${device.mobileL}{
    min-width: 200px;
  }
  `

export const Button = styled.button`
  margin-left: 6px;
  margin-right: 20px;
  -webkit-appearance: none;
  background: linear-gradient( rgba(24,112,57,0.86), rgba(162,210,81,0.83));
  color: #ffffff;
  text-align: center;
  padding: 10px 14px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  border: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2)
`
